import { render, staticRenderFns } from "./ChatContact.vue?vue&type=template&id=4c23a061"
import script from "./ChatContact.vue?vue&type=script&lang=js"
export * from "./ChatContact.vue?vue&type=script&lang=js"
import style0 from "./ChatContact.vue?vue&type=style&index=0&id=4c23a061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports